// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'lib-flexible/flexible'
import '@/assets/css/main.css'
import router from './router'
import '@/assets/iconfont/iconfont.css'
import Router from 'vue-router'
import 'babel-polyfill'
import '@/assets/vant/vant.js'
import '@/assets/resetVui.scss'
import store from './store/module'
import '@/assets/js/directives.js'
import Vconsole from 'vconsole'
//非正式环境才有
if(window.location.hash.indexOf('showConsole') != -1 || window.location.hostname !== 'hq.zjrhjy.cn'){
    new Vconsole()
  }
// const vConsole = new Vconsole
// Vue.use(vConsole)
Vue.config.productionTip = false

// 禁止在微信浏览器以外的窗口打开
// var ua = navigator.userAgent.toLowerCase();
// var isWeixin = ua.indexOf('micromessenger') != -1;
// if (!isWeixin) {
//   window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=888"
// }

// 解决vue-router 跳转不是promise报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 监听路由来实现过渡动画
window.addEventListener('popstate', function(e) {
    router.isBack = true
})

Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js